export const USER_PROMPT_LOAD_REQUESTED = "USER_PROMPT/LOAD_REQUESTED";
export const USER_PROMPT_LOAD_SUCCESS = "USER_PROMPT/LOAD_SUCCESS";
export const USER_PROMPT_LOAD_FAIL = "USER_PROMPT/LOAD_FAIL";
export const USER_PROMPT_SAVE_REQUESTED = "USER_PROMPT/SAVE_REQUESTED";
export const USER_PROMPT_SAVE_SUCCESS = "USER_PROMPT/SAVE_SUCCESS";
export const USER_PROMPT_SAVE_FAIL = "USER_PROMPT/SAVE_FAIL";

export const defaultScopeId = "v3.AI.chainInstance.userPrompt";

export default (state = {
  loading: 0,
  data: "",
  errors: []
}, { type, data }) => {
  switch (type) {
  case USER_PROMPT_LOAD_REQUESTED: {
    ++state.loading;
    return state;
  }
  case USER_PROMPT_LOAD_SUCCESS: {
    --state.loading;
    state.data = data;
    return state;
  }
  case USER_PROMPT_LOAD_FAIL: {
    --state.loading;
    // state.errors.push({ error: data, type });
    return state;
  }
  case USER_PROMPT_SAVE_REQUESTED: {
    ++state.loading;
    return state;
  }
  case USER_PROMPT_SAVE_SUCCESS: {
    --state.loading;
    state.data = data;
    return state;
  }
  case USER_PROMPT_SAVE_FAIL: {
    --state.loading;
    state.errors.push({ error: data, type });
    return state;
  }
  default:
    return state;
  }
};

export const loadRequested = data => ({ type: USER_PROMPT_LOAD_REQUESTED, data });
export const loadSuccess = data => ({ type: USER_PROMPT_LOAD_SUCCESS, data });
export const loadFail = data => ({ type: USER_PROMPT_LOAD_FAIL, data });
export const saveRequested = data => ({ type: USER_PROMPT_SAVE_REQUESTED, data });
export const saveSuccess = data => ({ type: USER_PROMPT_SAVE_SUCCESS, data });
export const saveFail = data => ({ type: USER_PROMPT_SAVE_FAIL, data });
